const transferAmountBetweenCurrencies = {
    "d": {
        
    }
};
export default transferAmountBetweenCurrencies;